<template>
  <v-overlay :value="isLoading">
    <v-container style="height: 400px;">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          {{ message }}
        </v-col>
        <v-col cols="6">
          <v-progress-circular
            v-if="progressTypeDefault"
            :color="color"
            :size="size"
            indeterminate
            rounded
            height="6"
          />
          <v-progress-linear
            v-else
            :color="color"
            :size="size"
            indeterminate
            rounded
            height="6"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading...",
    },
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "50",
    },
    progressTypeDefault: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
